import { isPublicAuthPath } from "@/utilities/navigation";
import { Outlet, useRouterState } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const PublicAuthLayout = lazy(() =>
  import("./public-auth-layout").then((module) => ({
    default: module.PublicAuthLayout,
  })),
);

/** Own the globe above the changing route component so it stays mounted. */
export function PublicAuthOutlet() {
  // The location changes before loaders finish; matches track the rendered page.
  const showAuthLayout = useRouterState({
    select: (state) =>
      state.matches.some(
        (match) =>
          isPublicAuthPath(match.pathname) ||
          match.pathname === "/account-setup",
      ),
  });

  return showAuthLayout ? (
    <Suspense fallback={null}>
      <PublicAuthLayout>
        <Outlet />
      </PublicAuthLayout>
    </Suspense>
  ) : (
    <Outlet />
  );
}
